import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { BaseComponent } from '../../../core/components/base.component';

@Component({
  selector: 'app-mat-tabs',
  templateUrl: './mat-tabs.component.html',
  styleUrls: ['./mat-tabs.component.scss']
})
export class MatTabsComponent extends BaseComponent {
  level: number = 0;
  expanded: boolean = false;

  public links = [
    { path: '/idea', label: 'Navigation.Idea' },
    { path: '/foundation', label: 'Navigation.Foundation' },
    { path: '/startphase', label: 'Navigation.Growth' },
    { path: '/scaling', label: 'Navigation.Succession' }
  ];
  constructor(private readonly router: Router) {
    super();
  }
 
  protected onClick(event: MouseEvent): void {
    event.stopPropagation();
    event.preventDefault();
    this.expanded = !this.expanded;
  }
}
